export default "__VITE_ASSET__CHCT0uZJ__"